export default __webpack_public_path__ + "static/media/IconDesc_XmasBall_Silver.256.c1dcfb47.png";